<template>
</template>

<script>
export default {

}
localStorage.token=''
</script>

<style>

</style>